import { render, staticRenderFns } from "./IssueSerial.vue?vue&type=template&id=3c924bf2&scoped=true&"
import script from "./IssueSerial.vue?vue&type=script&lang=js&"
export * from "./IssueSerial.vue?vue&type=script&lang=js&"
import style0 from "./IssueSerial.vue?vue&type=style&index=0&id=3c924bf2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c924bf2",
  null
  
)

export default component.exports